<template>
    <div @click="contextMenuVisible = false" >
        <!-- 右键菜单 -->
        <div
                v-show="contextMenuVisible"
                :style="{ position: 'absolute', top: menuPosition.y + 'px', left: menuPosition.x + 'px', zIndex: 2000 }"
                class="context-menu"
                @click.stop>
            <el-menu
                    default-active="2"
                    class="el-menu-vertical-demo"
                    @click.native.stop>
                <el-menu-item @click="removeAll">关闭所有标签</el-menu-item>
                <el-menu-item @click="closeLeft">关闭左边标签</el-menu-item>
                <el-menu-item @click="closeRight">关闭右边标签</el-menu-item>
                <el-menu-item @click="closeOther">关闭其他标签</el-menu-item>
            </el-menu>
        </div>

        <el-tabs v-model="editableTabsValue" @tab-click="handleClick" type="card" closable @tab-remove="removeTab" @contextmenu.prevent.native="handleRightClick($event)" class="custom-tabs">
            <el-tab-pane
                    v-for="(item, index) in editableTabs"
                    :key="item.name"
                    :label="item.desc"
                    :name="item.name"
            >
                <component :is="item.value" :status="item.status" :paramsInfo="paramsInfo"  ></component>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>


<script>
    import CustomerStat from "./company-stat/customer-stat";
    import UserStat from "./company-stat/user-stat";
    import orderStat from "./company-stat/order-stat";
    import DevStat from "./dev/dev-stat";
    import GroupStat from "./dev/group-stat";
    import SimStat from "./dev/sim-stat";
    import DevStatHistory from "./dev/dev-stat-history";
    import SoftStat from "./dev/soft-stat";

    import EarlyWarningStat from "./early-warning/early-warning-stat";
    import DevWarningStat from "./early-warning/dev-warning-stat";
    import SmStat from "./early-warning/sm-stat";


    import DictInfo from "./auth/dictInfo";
    import AuthUser from "./auth/auth-user";
    import AuthRole from "./auth/auth-role";
    import OperationLog from "./auth/operation-log";
    export default {
        name: "home-page",
        components: {
            CustomerStat,DictInfo,AuthUser,AuthRole,orderStat,DevStat,GroupStat,SimStat,SoftStat,DevStatHistory,
            UserStat,EarlyWarningStat,SmStat,OperationLog,DevWarningStat
        },
        props: ['menuPath'], // 由于我们在路由中设置了 props: true，type 将作为 prop 传入
        data () {
            return {
                editableTabsValue: '',
                contextMenuVisible: false,
                menuPosition: { x: 0, y: 0 },
                contextMenuStyle: {
                    position: 'fixed',
                    top: '0px',
                    left: '0px'
                },
                paramsInfo:{},
                editableTabs: [],
                tabIndex: 0,
                vehicleStatus:"Active",
                mainData:[
                    {"desc": "用户管理", "name": "user-stat", "value": "UserStat","status":0},
                    {"desc": "客户管理", "name": "customer-stat", "value": "CustomerStat","status":0},
                    {"desc": "订单管理", "name": "order-stat", "value": "orderStat","status":0},

                    {"desc": "设备管理", "name": "dev-stat", "value": "DevStat","status":0},
                    {"desc": "业务预警", "name": "early-warning-stat", "value": "EarlyWarningStat","status":0},
                    {"desc": "设备预警", "name": "dev-warning-stat", "value": "DevWarningStat","status":0},
                    {"desc": "短信查询", "name": "sm-stat", "value": "SmStat","status":0},
                    {"desc": "分组管理", "name": "group-stat", "value": "GroupStat","status":0},
                    {"desc": "上报记录", "name": "dev-stat-history", "value": "DevStatHistory","status":0},
                    {"desc": "流量卡管理", "name": "sim-stat", "value": "SimStat","status":0},
                    {"desc": "设备软件管理", "name": "soft-stat", "value": "SoftStat","status":0},

                    {"desc": "字典管理", "name": "dictInfo", "value": "DictInfo","status":0},
                    {"desc": "账号管理", "name": "auth-user", "value": "AuthUser","status":0},
                    {"desc": "角色管理", "name": "auth-role", "value": "AuthRole","status":0},
                    {"desc": "操作日志", "name": "operation-log", "value": "OperationLog","status":0},
                ],
                fallData:[
                    {"desc": "用户管理", "name": "user-stat", "value": "UserStat", "status": 0, "fullName": "/Home/main/company-stat/user-stat"},
                    {"desc": "客户管理", "name": "customer-stat", "value": "CustomerStat", "status": 0, "fullName": "/Home/main/company-stat/customer-stat"},
                    {"desc": "订单管理", "name": "order-stat", "value": "orderStat", "status": 0, "fullName": "/Home/main/company-stat/order-stat"},

                    {"desc": "设备管理", "name": "dev-stat", "value": "DevStat", "status": 0, "fullName": "/Home/main/dev/dev-stat"},
                    {"desc": "业务预警", "name": "early-warning-stat", "value": "EarlyWarningStat", "status": 0, "fullName": "/Home/main/early-warning/early-warning-stat"},
                    {"desc": "设备预警", "name": "dev-warning-stat", "value": "DevWarningStat", "status": 0, "fullName": "/Home/main/early-warning/dev-warning-stat"},
                    {"desc": "短信", "name": "sm-stat", "value": "SmStat", "status": 0, "fullName": "/Home/main/early-warning/sm-stat"},
                    {"desc": "设备管理", "name": "group-stat", "value": "GroupStat", "status": 0, "fullName": "/Home/main/dev/group-stat"},
                    {"desc": "上报记录", "name": "dev-stat-history", "value": "DevStatHistory", "status": 0, "fullName": "/Home/main/dev/dev-stat-history"},
                    {"desc": "设备管理", "name": "sim-stat", "value": "SimStat", "status": 0, "fullName": "/Home/main/dev/sim-stat"},
                    {"desc": "设备管理", "name": "soft-stat", "value": "SoftStat", "status": 0, "fullName": "/Home/main/dev/soft-stat"},

                    {"desc": "字典管理", "name": "dictInfo", "value": "DictInfo", "status": 0, "fullName": "/Home/main/auth/dictInfo"},
                    {"desc": "账号管理", "name": "auth-user", "value": "AuthUser", "status": 0, "fullName": "/Home/main/auth/auth-user"},
                    {"desc": "角色管理", "name": "auth-role", "value": "AuthRole", "status": 0, "fullName": "/Home/main/auth/auth-role"},
                    {"desc": "操作日志", "name": "operation-log", "value": "OperationLog", "status": 0, "fullName": "/Home/main/auth/operation-log"}
                 ],
                showContextMenu: false,
                currentTab: null,
            }
        },
        watch: {
            '$route' (to, from) {
                // 将参数传给组件
                this.paramsInfo = to.query;
                // 在这里你可以做更多的逻辑处理
                let newPath = to.path;
                // 判断是否存在
                this.dealTab(newPath);
                // 刷新页面
                this.flashPage();
            },

            contextMenuVisible() { //监听 右键关闭菜单 点击任何地方 菜单消失
                if (this.contextMenuVisible) {
                    document.body.addEventListener("click", this.closeMenu);
                } else {
                    document.body.removeEventListener("click", this.closeMenu);
                }
            }
        },
        created: function () {
            let pathname = window.location.pathname;  // 获取路径部分
            this.dealTab(pathname);
        },
        methods:{
            flashPage(){
                this.editableTabs.forEach(item=>{
                    if (item.name  == this.editableTabsValue) {
                        item.status = 1;
                    }else {
                        item.status =0;
                    }
                })
            },
            removeTab(targetName) {
                this.editableTabs = this.editableTabs.filter(tab => tab.name !== targetName);
                if (this.editableTabs.length && this.editableTabsValue === targetName) {
                    this.editableTabsValue = this.editableTabs[0].name;
                }
            },
            dealTab(newPath){
                // 选择所有类名为 'is-closable' 的元素
                var closableElements = document.querySelectorAll('.is-closable');

                // 遍历这些元素并删除 color 属性
                closableElements.forEach(function(element) {
                    element.style.color = ''; // 将 color 设置为空字符串，即移除直接设置的颜色
                });
                // 选择所有类名为 'el-tab-pane' 的元素
                var tabPanes = document.querySelectorAll('.el-tab-pane');

                // 遍历这些元素并设置 display 属性为 'none'
                // tabPanes.forEach(function(pane) {
                //     pane.style.display = 'none';
                // });

                // 使用 lastIndexOf 方法找到最后一个 '/' 的位置
                const lastIndex = newPath.lastIndexOf('/');
                // 使用 substring 方法从最后一个 '/' 之后的位置开始截取字符串
                const lastPart = newPath.substring(lastIndex + 1);
                let existPath  = false;
                // 存在显示当前页面
                for (let i = 0; i < this.editableTabs.length; i++) {
                    let item = this.editableTabs[i];
                    if(lastPart == item.name){
                        this.editableTabsValue = lastPart ;
                        existPath = true;
                        this.tabIndex = i;
                        break;
                    }
                }
                // 不存在直接添加
                if (!existPath) {
                    const lastPart = newPath.substring(lastIndex + 1);
                    for (let i = 0; i < this.mainData.length; i++) {
                        let item = this.mainData[i];
                        if(lastPart == item.name){

                            this.editableTabs.push(item);
                            this.tabIndex = this.editableTabs.length;
                            this.editableTabsValue = lastPart ;

                            break;
                        }
                    }
                }
            },
            handleClick(tab, event) {
                // 刷新页面 传参数
                this.flashPage();
                // 修改浏览器中的url
                window.history.pushState({}, '', tab.name);
                // 修改左边菜单栏 打开状态
                this.$store.dispatch('SetCurrentTab', tab.label);
            },
            handleRightClick(event) {
                this.contextMenuVisible = false;
                if (event.srcElement.id) {
                    // 右键点击的是tab
                    console.log(event);
                    this.currentTab = event.srcElement.innerText;
                    event.preventDefault();
                    this.contextMenuVisible = true;
                    this.menuPosition = { x: event.clientX, y: event.clientY };
                }
            },
            // 关闭所有标签
            removeAll() {
                this.editableTabs = [];
                this.currentTab = "";
                this.contextMenuVisible = false
            },
            // 关闭左边标签
            closeLeft() {
                let index = 0;

                let obj = {}; // 当前标签
                this.editableTabs.forEach((el, i) => {
                    if (this.currentTab == el.desc) {
                        index = i;
                        obj = el;
                    }
                });
                this.editableTabs = this.editableTabs.slice(index);
                this.contextMenuVisible = false
                this.editableTabsValue = obj.name;
            },

            // 关闭右边标签
            closeRight() {
                let index = 0;
                let obj = {}; // 当前标签
                this.editableTabs.forEach((el, i) => {
                    if (this.currentTab == el.desc) {
                        index = i;
                        obj = el;
                    }
                });
                this.editableTabs = this.editableTabs.slice(0, index + 1);
                this.contextMenuVisible = false;
                this.editableTabsValue = obj.name;

            },
            // 关闭其他标签
            closeOther() {
                let obj = {}; // 当前标签
                this.editableTabs.forEach((el) => {
                    if (this.currentTab == el.desc) {
                        obj = el;
                    }
                });
                this.editableTabs = [obj];
                this.editableTabsValue = obj.name;

                this.contextMenuVisible = false
            },

        }
    }
</script>
<style lang="less" scoped>
    .context-menu {
        border: 1px solid #d3dce6;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    }

    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 150px;
    }

    .custom-tabs /deep/ .el-tabs__header {
        border-bottom: 1px solid #e4e7ed; /* 恢复默认的下边框 */
    }

    .custom-tabs /deep/ .el-tabs__item.is-active {
        border-bottom: 2px solid #409EFF; /* 恢复默认的活动标签下边框 */
        color: #409EFF;
    }
    .custom-tabs  /deep/ .el-tabs__item {
        color: #827f7f;
    }
    .custom-tabs  /deep/ .el-tabs__item:hover {
        border-bottom: 2px solid #409EFF; /* 恢复默认的活动标签下边框 */
        color: #409EFF;
    }

</style>
